import { render, staticRenderFns } from "./PasswordRecoverSms.vue?vue&type=template&id=4b4417b9"
import script from "./PasswordRecoverSms.vue?vue&type=script&lang=js"
export * from "./PasswordRecoverSms.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecoverSms.vue?vue&type=style&index=0&id=4b4417b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports